import { IDR } from '@/libs/currency'
import { NODASH_MONTH_YEAR } from '@/libs/filterDate'

const tableColumnMapper = columns => columns.map(column => ({
  tdClass: 'text-[#333333] !py-[12px] !px-[24px]',
  ...column,
  thStyle: {
    ...column.thStyle,
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    fontWeight: '500',
    color: '#333333',
    background: '#F4F4F4',
    padding: '12px 24px',
  },
}))

const miniTableColumnMapper = columns => columns.map(column => ({
  tdClass: `text-[#1E2939] text-[14px] !p-[16px] !border-t-[1px] !border-t-[#F3F4F6] font-normal whitespace-nowrap ${column.key === 'key' ? 'text-left' : 'text-right'}`,
  ...column,
  thStyle: {
    ...column.thStyle,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    fontSize: '12px',
    fontWeight: '700',
    color: '#4A5565',
    background: '#F9FAFB',
    padding: '16px',
    borderBottom: '1px solid #E5E7EB',
    textAlign: column.key === 'key' ? 'left' : 'right',
  },
}))

export const adminMarketplaceColumns = tableColumnMapper([
  {
    key: 'no',
    label: 'No',
  },
  {
    key: 'talent_name',
    label: 'Nama Talent',
    tdClass: 'text-[#333333] !py-[12px] !px-[24px] whitespace-nowrap',
  },
  {
    key: 'partner_name',
    label: 'Partner',
    tdClass: 'text-[#333333] !py-[12px] !px-[24px] whitespace-nowrap',
  },
  {
    key: 'period',
    label: 'Periode',
    tdClass: 'text-[#333333] !py-[12px] !px-[24px] whitespace-nowrap',
    formatter: value => NODASH_MONTH_YEAR(value),
  },
  {
    key: 'talent_lead',
    label: 'Talent Lead',
    tdClass: 'text-[#333333] !py-[12px] !px-[24px] whitespace-nowrap',
  },
  {
    key: 'status',
    label: 'Status',
    tdClass: 'text-[#333333] !py-[12px] !px-[24px] w-[147px] capitalize',
  },
  {
    key: 'action',
    label: 'Link',
    tdClass: '!py-[12px] !px-[24px] text-[#08A0F7] max-w-[190px] truncate',
  },
])

export const incentiveColumns = miniTableColumnMapper([
  {
    key: 'key',
    label: 'item',
  },
  {
    key: 'value',
    label: 'keterangan',
  },
  {
    key: 'nominal',
    label: 'nominal (rp)',
    formatter: value => (value ? IDR(value) : 'Rp. -'),
  },
])

export const baseSalaryColumns = miniTableColumnMapper([
  { key: 'key' }, { key: 'days' }, { key: 'nominal', formatter: value => (value ? IDR(value) : '-') },
])

export const otherColumns = miniTableColumnMapper([
  { key: 'key' }, { key: 'nominal' },
])

export const reportStatusOptions = [
  {
    text: 'Diajukan',
    value: 'submitted',
  },
  {
    text: 'Revisi',
    value: 'revision',
  },
  {
    text: 'Diverifikasi',
    value: 'verified',
  },
]

export const workingDaysMap = {
  Kehadiran: 'present_days',
  Sakit: 'sick_days',
  Izin: 'leave_days',
  'Tidak Hadir': 'absent_days',
}
